<div class="notice-container-form">
  <div class="header">
    <span>{{ !noticeToEdit ? "Ajouter une nouvelle annonce" : "Éditer l'annonce " + noticeToEdit.title }}</span>
  </div>
  <div class="form" [formGroup]="form">
    <mat-form-field appearance="outline" class="title">
      <mat-label>Titre</mat-label>
      <input matInput type="text" formControlName="title" required>
    </mat-form-field>

    <mat-card class="editor-description">
      <angular-editor formControlName="content" [config]="editorConfig" placeholder="Description"></angular-editor>
    </mat-card>

    <!-- <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="content" maxlength="500"></textarea>
    </mat-form-field> -->

    <div class="check-zone">
      <mat-checkbox formControlName="left"><span>Bloc de gauche</span></mat-checkbox>
      <mat-checkbox formControlName="right"><span>Bloc de droite</span></mat-checkbox>
    </div>

    <mat-form-field appearance="outline" class="url">
      <mat-label>Url</mat-label>
      <input matInput type="text" formControlName="url">
    </mat-form-field>

    <mat-form-field appearance="outline" class="label-url">
      <mat-label>Label Url</mat-label>
      <input matInput type="text" formControlName="label">
    </mat-form-field>

    <div class="image">
      <div class="thumbimage">
        <div class="input_uplaod_perso" appChangeColorTheme attribute="bgc">
          <button type="button" mat-raised-button (click)="fileInput.click()">Importer une image</button>
          <input type="file" hidden #fileInput class="input_default_file" (input)="selectImage($event)" />
        </div>
      </div>
      <div class="filename" *ngIf="file">
        <div class="name">{{ file.name }}</div>
        <fa-icon [icon]="getFaIcon('faTrash')" (click)="deleteName()" matTooltip="Supprimer" matTooltipPosition="above"></fa-icon>
      </div>
    </div>
    <div class="file-upload" *ngIf="noticeToEdit?.thumbImage">
      <div class="name" [innerHTML]="noticeToEdit.thumbImage"></div>
      <fa-icon [icon]="getFaIcon('faTrash')" (click)="deleteImage(noticeToEdit)" matTooltip="Supprimer une image" matTooltipPosition="above"></fa-icon>
    </div>
  </div>

  <div class="actions">
    <ng-container *ngIf="!isLoading; else loadingTemplate">
      <button mat-raised-button class="cancel" (click)="cancel()">Annuler</button>
      <button mat-raised-button [disabled]="form.invalid" class="save" (click)="save()">
        <span>{{ !noticeToEdit ? "Ajouter" : "Sauvegarder"}}</span>
      </button>
    </ng-container>

    <ng-template #loadingTemplate>
      <mat-spinner diameter="50"></mat-spinner>
    </ng-template>
  </div>
</div>
